import { faCheckCircle, faRefresh } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react'
import { Row, Col, Card } from 'react-bootstrap'
import { UsersCard } from '../../component/Card/Statistics.card'
import { ClientService } from '../../component/services/client.service'
import toast from 'react-hot-toast'
import moment from 'moment'
import CetLoader from '../../component/Loader/CetLoader'
import { FaCircleMinus, FaCirclePlus } from 'react-icons/fa6'
import "../../component/Card/card.css"

interface ICSRStats {
    shift: any;
    selectedCenters: any;
    selectedZones: any;
    selectedDistrict: any;
    selectedStates: any;
    states: any,
    cities: any,
    selectedCourses: any
}

// Export interface for the ref
export interface CsrStatsIndexRef {
    getCountData: () => void;
}

const CsrStatsIndex = forwardRef<CsrStatsIndexRef, ICSRStats>((props, ref) => {

    const [countData, setCountData] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [loading2, setLoading2] = useState<boolean>(false);

    const [isActive, setIsActive] = useState<boolean>(false);
    const [verificationData, setVerificationData] = useState<any>({});

    const didMountRef = useRef(false)

    const getCountData = async () => {
        const payload = {
            state: props.selectedStates?.map((data: any) => data?.value),
            city: props.selectedDistrict?.map((data: any) => data?.value),
            zone: props.selectedZones?.map((data: any) => data?.value),
            centerId: props.selectedCenters?.map((data: any) => data?.value),
            courseName: props.selectedCourses?.map((data: any) => data?.value),
        }
        setLoading(true);
        await ClientService.getCountInfo(props.shift, payload)
            .then((res) => {
                if (res.status === 200) {
                    setCountData(res.data);
                }
            })
            .catch((err) => {
                console.log(err);
                toast.error(err.response.data);
            })
            .finally(() => setLoading(false));
    };

    async function getVerificationWiseCount() {
        const payload = {
            state: props.selectedStates?.map((data: any) => data?.value),
            city: props.selectedDistrict?.map((data: any) => data?.value),
            zone: props.selectedZones?.map((data: any) => data?.value),
            centerId: props.selectedCenters?.map((data: any) => data?.value),
            courseName: props.selectedCourses?.map((data: any) => data?.value),
        }
        setLoading2(true);
        await ClientService.getVerificationWiseCount(props.shift, payload)
            .then((res) => {
                if (res.status === 200) {
                    setVerificationData(res.data);
                    setIsActive(true);
                }
            })
            .catch((err) => {
                console.log(err);
                toast.error(err.response.data);
            })
            .finally(() => setLoading2(false));
    }

    async function fetchData() {
        await getCountData();
        if (props.selectedCenters && props.selectedCenters.length > 0) {
            await getVerificationWiseCount();
        }
    }


    useImperativeHandle(ref, () => ({
        getCountData: fetchData
    }));

    useEffect(() => {
        if (!props.selectedCenters || props.selectedCenters.length === 0) {
            setVerificationData({});
            setIsActive(false);
        }
    }, [props.selectedCenters]);

    //  useEffect(() => {
    //     if (!props.shift) return

    //     if (!didMountRef.current) {
    //     didMountRef.current = true
    //     return
    //     }

    //     getCountData()
    // }, [
    //     props.shift,
    //     props.selectedCenters,
    //     props.selectedZones,
    //     props.selectedDistrict,
    //     props.selectedStates,
    //     props.selectedCourses,
    // ])

    // useEffect(() => {
    //     if (props.shift) {
    //         getCountData();
    //     }
    // }, [props.shift, props.selectedCenters, props.selectedZones, props.selectedDistrict, props.selectedStates, props.selectedCourses]);

    return (
        <>
            <Row className="mt-3">
                <Col>
                    <Card
                        style={{
                            backgroundColor: "#dcdcdc",
                            borderRadius: "12px",
                            border: "none",
                        }}
                    >
                        <div className="d-flex align-items-center  justify-content-end ">
                            <FontAwesomeIcon icon={faRefresh} className='m-2 cursor-pointer' onClick={fetchData} />
                        </div>
                        <Card
                        >
                            <Card.Body>
                                {
                                    loading ? <CetLoader /> :
                                        <>
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <div>
                                                    <h6>Statistics</h6>
                                                </div>
                                            </div>
                                            <Row>
                                                <Col md={3}>
                                                    <UsersCard
                                                        reactIcon={<FontAwesomeIcon icon={faCheckCircle} className="fs-1 text-muted" />}
                                                        header={"Schedule Candidates"}
                                                        statsValue={countData?.["Users Count"] || 0}
                                                        style={{ backgroundColor: "#11009E", color: "white" }}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <UsersCard
                                                        reactIcon={<FontAwesomeIcon icon={faCheckCircle} className="fs-1 text-muted" />}
                                                        header={"Present Candidates"}
                                                        statsValue={countData?.["Attendance Count"] || 0}
                                                        style={{ backgroundColor: "#004A2F", color: "white" }}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <UsersCard
                                                        reactIcon={<FontAwesomeIcon icon={faCheckCircle} className="fs-1 text-muted" />}
                                                        header={"Sync Candidates"}
                                                        statsValue={countData?.["Sync Count"] || 0}
                                                        style={{ backgroundColor: "#6C946F", color: "white" }}
                                                    />
                                                </Col>

                                                <Col md={3}>
                                                    <UsersCard
                                                        reactIcon={<FontAwesomeIcon icon={faCheckCircle} className="fs-1 text-muted" />}
                                                        header={"Absent Candidates"}
                                                        statsValue={countData?.["Users Count"] - countData?.["Attendance Count"] || 0}
                                                        style={{ backgroundColor: "#6C946F", color: "white" }}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <UsersCard
                                                        reactIcon={<FontAwesomeIcon icon={faCheckCircle} className="fs-1 text-muted" />}
                                                        header={"Verified with Execption"}
                                                        statsValue={countData?.["By-Passed Total"] || 0}
                                                        style={{ backgroundColor: "#AED09E", color: "white" }}
                                                    />
                                                </Col>
                                            </Row>

                                            {/* <Row>
                                                {countData?.verification_data?.filter((data: any) => data.method !== "gps")?.map((data: any, index: number) => (
                                                    <Col md={3} key={index}>
                                                        <UsersCard
                                                            reactIcon={<FontAwesomeIcon icon={faCheckCircle} className="fs-1 text-muted" />}
                                                            header={
                                                                data?.method === "fingerprint"
                                                                    ? "Right Fingerprint"
                                                                    : data?.method === "fingerprint2"
                                                                        ? "Left Fingerprint"
                                                                        : data?.method
                                                            }
                                                            statsValue={data?.total || 0}
                                                            style={{
                                                                backgroundColor: data?.method === "fingerprint"
                                                                    ? "#9B7EBD"
                                                                    : data?.method === "fingerprint2"
                                                                        ? "#7E60BF"
                                                                        : "#433878",
                                                                color: "white"
                                                            }}
                                                        />
                                                    </Col>
                                                ))}
                                                <Col md={3} className='d-flex justify-content-center align-items-center'>
                                                    {isActive ?
                                                        <FaCircleMinus className='d-flex justify-content-center align-items-center text-center xcn_plus_icon' size={50} onClick={() => setIsActive(false)} /> :
                                                        <FaCirclePlus className='d-flex justify-content-center align-items-center text-center xcn_plus_icon' size={50} onClick={() => setIsActive(true)} />
                                                    }
                                                </Col>

                                                {isActive &&
                                                    <>
                                                        {countData?.verification_data_exp?.filter((data: any) => data.method !== "gps")?.map((data: any, index: number) => (
                                                            <Col md={3} key={index}>
                                                                <UsersCard
                                                                    reactIcon={<FontAwesomeIcon icon={faCheckCircle} className="fs-1 text-muted" />}
                                                                    header={
                                                                        data?.method === "fingerprint"
                                                                            ? "Right Fingerprint Exception"
                                                                            : data?.method === "fingerprint2"
                                                                                ? "Left Fingerprint Exception"
                                                                                : `${data?.method} Exception`
                                                                    }
                                                                    statsValue={data?.exceptionCount || 0}
                                                                    style={{
                                                                        backgroundColor: data?.method === "fingerprint"
                                                                            ? "#A888B5"
                                                                            : data?.method === "fingerprint2"
                                                                                ? "#8174A0"
                                                                                : "#441752",
                                                                        color: "white"
                                                                    }}
                                                                />
                                                            </Col>
                                                        ))}
                                                    </>
                                                }
                                            </Row> */}


                                            {
                                                loading2 ? <CetLoader /> :
                                                    isActive ?
                                                        (
                                                            <>
                                                                <Row className='mt-3'>
                                                                    <Col md={12}>
                                                                        <p className='text-muted'>Verification Stats for <i className='fw-bold'>{props?.selectedCenters?.map((center: any) => center.label).join(", ")}</i></p>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    {verificationData?.verification_data?.filter((data: any) => data.method !== "gps")?.map((data: any, index: number) => (
                                                                        <Col md={3} key={index}>
                                                                            <UsersCard
                                                                                reactIcon={<FontAwesomeIcon icon={faCheckCircle} className="fs-1 text-muted" />}
                                                                                header={
                                                                                    data?.method === "fingerprint"
                                                                                        ? "Right Fingerprint"
                                                                                        : data?.method === "fingerprint2"
                                                                                            ? "Left Fingerprint"
                                                                                            : data?.method
                                                                                }
                                                                                statsValue={data?.total || 0}
                                                                                style={{
                                                                                    backgroundColor: data?.method === "fingerprint"
                                                                                        ? "#9B7EBD"
                                                                                        : data?.method === "fingerprint2"
                                                                                            ? "#7E60BF"
                                                                                            : "#433878",
                                                                                    color: "white"
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    ))}
                                                                </Row>
                                                                <Row>
                                                                    {verificationData?.verification_data_exp?.filter((data: any) => data.method !== "gps")?.map((data: any, index: number) => (
                                                                        <Col md={3} key={index}>
                                                                            <UsersCard
                                                                                reactIcon={<FontAwesomeIcon icon={faCheckCircle} className="fs-1 text-muted" />}
                                                                                header={
                                                                                    data?.method === "fingerprint"
                                                                                        ? "Right Fingerprint Exception"
                                                                                        : data?.method === "fingerprint2"
                                                                                            ? "Left Fingerprint Exception"
                                                                                            : `${data?.method} Exception`
                                                                                }
                                                                                statsValue={data?.exceptionCount || 0}
                                                                                style={{
                                                                                    backgroundColor: data?.method === "fingerprint"
                                                                                        ? "#A888B5"
                                                                                        : data?.method === "fingerprint2"
                                                                                            ? "#8174A0"
                                                                                            : "#441752",
                                                                                    color: "white"
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    ))}
                                                                </Row>
                                                            </>
                                                        )
                                                        :
                                                        <></>
                                            }

                                        </>
                                }

                            </Card.Body>
                        </Card>
                    </Card>
                </Col>
            </Row>
        </>
    )
});

CsrStatsIndex.displayName = 'CsrStatsIndex';

export default CsrStatsIndex;